module.exports = __webpack_public_path__ + "static/media/ios-fitness.d7cce0c4.svg";